import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import grey from '@material-ui/core/colors/grey';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import i18n from '../resources/i18n';

import { IApprovalStayMealData } from 'src/actions/search';
import {
	IApplication,
	IApplicationStayMeal,
	setChangeApplicationData,
	showChangeApplicationDialog,
} from '../actions/imstat';
import { IMessage } from '../actions/message';
import MessageDialog from '../components/MessageDialog';
import { IRootState } from '../reducers';
import ImstatScenarioFactory, {
	IFetchChangeApplicationParam,
} from '../scenario/ImstatScenarioFactory';

const styles = (theme: Theme) =>
	createStyles({
		button: {
			margin: '10px',
		},
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '150px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		column: {
			display: 'inline-block',
			textAlign: 'center',
			width: '33.33%',
		},
		flex: {
			flex: 1,
		},
		paper: {
			minWidth: '700px',
		},
		root: {
			flexGrow: 1,
			padding: 18,
			wordBreak: 'break-all',
		},
		tableLayout: {
			tableLayout: 'fixed',
		},
		textArea: {
			width: '100%',
		},
		whiteSpace: {
			whiteSpace: 'normal',
		},
		whiteSpaceMenuItem: {
			whiteSpace: 'normal',
			'word-break': 'break-all',
		},
		width: {
			width: '100%',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

interface IRouteParams {
	career_id: string;
	class_id: string;
}

interface IRouteState {
	caller: Parameters<IProps['pushHistory']>[0];
}

interface IState {
	careerID: string;
	classID: string;
	openErrorMessageDialog: boolean;
	messages: IMessage[];
}

/**
 * 受講申請変更
 */
class ApplicationChangeForSkill extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			careerID: '',
			classID: '',
			messages: [],
			openErrorMessageDialog: false,
		};

		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.onDialogOk = this.onDialogOk.bind(this);
		this.onChangeReason = this.onChangeReason.bind(this);
		this.onChangeApprover = this.onChangeApprover.bind(this);
		this.changeApplication = this.changeApplication.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const careerID = this.props.match.params.career_id;
		const classID = this.props.match.params.class_id;
		this.setState({
			careerID,
			classID,
		});

		this.props.fetchChangeApplication(this.props.token, {
			careerID,
			classID,
			userAttr: this.props.userAttr,
		});
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.setChangeApplicationData({});
	}

	public render() {
		const { classes, data } = this.props;
		const showApprovers =
			data.approve1List || data.approve2List || data.approve4List;
		let kikan = data.kikan;
		if (kikan && kikan.indexOf('～') !== -1) {
			kikan = kikan.replace(
				'～',
				i18n.t('～', {
					ns: 'force',
				})
			);
		}
		return (
			<div className={classes.root}>
				<div className={classes.wrapDiv}>
					<Paper className={classes.paper}>
						<Table className={this.props.classes.tableLayout}>
							<TableBody>
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t(
											'ApplicationChangeForSkill_0001'
										)}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										{data.careerTitle}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t(
											'ApplicationChangeForSkill_0002'
										)}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										{data.className &&
										data.className === '個別実施期間'
											? i18n.t(data.className, {
													ns: 'force',
											  })
											: data.className}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t(
											'ApplicationChangeForSkill_0003'
										)}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										{kikan}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className={classes.cellItemName}>
										{i18n.t(
											'ApplicationChangeForSkill_0004'
										)}
									</TableCell>
									<TableCell
										className={classes.cellItemValue}
									>
										<TextField
											id="multiline-flexible"
											className={classes.textArea}
											multiline={true}
											rows="4"
											margin="normal"
											value={data.reason}
											onChange={this.onChangeReason}
										/>
									</TableCell>
								</TableRow>
								{showApprovers && (
									<TableRow>
										<TableCell
											className={classes.cellItemName}
										>
											{i18n.t(
												'ApplicationChangeForSkill_0005'
											)}
										</TableCell>
										<TableCell
											className={classes.cellItemValue}
										>
											{data.approve1List && (
												<div>
													<InputLabel htmlFor="acceptManagerUserID">
														{i18n.t(
															'ApplicationChangeForSkill_0006'
														)}
													</InputLabel>
													<Select
														id="approverId1"
														input={
															<Input
																name="acceptManagerUserID"
																id="acceptManagerUserID"
															/>
														}
														autoWidth={true}
														onChange={
															this
																.onChangeApprover
														}
														value={
															data.acceptManagerUserID
														}
														displayEmpty={true}
														classes={{
															selectMenu: this
																.props.classes
																.whiteSpace,
														}}
													>
														{data.approve1List.map(
															(
																approver: any,
																i: number
															): JSX.Element => (
																<MenuItem
																	key={i}
																	value={
																		approver.userId
																	}
																	className={
																		this
																			.props
																			.classes
																			.whiteSpaceMenuItem
																	}
																>
																	{
																		approver.approverOptionString
																	}
																</MenuItem>
															)
														)}
													</Select>
												</div>
											)}
											{data.approve2List && (
												<div>
													<InputLabel htmlFor="acceptManagerUserID">
														{i18n.t(
															'ApplicationChangeForSkill_0007'
														)}
													</InputLabel>
													<Select
														id="approverId2"
														input={
															<Input
																name="acceptManagerUserID2"
																id="acceptManagerUserID2"
															/>
														}
														autoWidth={true}
														onChange={
															this
																.onChangeApprover
														}
														value={
															data.acceptManagerUserID2
														}
														displayEmpty={true}
														classes={{
															selectMenu: this
																.props.classes
																.whiteSpace,
														}}
													>
														{data.approve2List.map(
															(
																approver: any,
																i: number
															): JSX.Element => (
																<MenuItem
																	key={i}
																	value={
																		approver.userId
																	}
																	className={
																		this
																			.props
																			.classes
																			.whiteSpaceMenuItem
																	}
																>
																	{
																		approver.approverOptionString
																	}
																</MenuItem>
															)
														)}
													</Select>
												</div>
											)}
										</TableCell>
									</TableRow>
								)}
							</TableBody>
						</Table>
					</Paper>
				</div>
				<div>
					<div className={classes.column} />
					<div className={classes.column}>
						<Button
							variant="contained"
							color="primary"
							onClick={this.changeApplication}
						>
							{i18n.t('ApplicationChangeForSkill_0008')}
						</Button>
					</div>
					<div className={classes.column} />
				</div>
				<MessageDialog
					open={this.props.dialogOpen}
					showCancelButton={false}
					title={i18n.t('ApplicationChangeForSkill_0009')}
					contents={[{ content: 'LMCM_I_00530' }]}
					onClose={this.onDialogOk}
					onClickOk={this.onDialogOk}
				/>
				<MessageDialog
					open={this.state.openErrorMessageDialog}
					showCancelButton={false}
					title={i18n.t('ApplicationChangeForSkill_0010')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
			</div>
		);
	}

	/**
	 * エラーメッセージクローズ
	 */
	protected errorMessageDialogClose() {
		this.setState({ openErrorMessageDialog: false, messages: [] });
	}

	/**
	 * メッセージダイアログと受講申請変更画面をクローズ
	 */
	protected onDialogOk() {
		this.props.onClose();
		this.props.pushHistory(this.props.location.state.caller);
	}

	/**
	 * 申請理由変更ハンドラ
	 * @param event
	 */
	protected onChangeReason(event: React.ChangeEvent<HTMLInputElement>) {
		const { data } = this.props;
		const newData = Object.assign({}, data);
		newData.reason = event.target.value;
		this.props.setChangeApplicationData(newData);
	}

	/**
	 * 承認者変更ハンドラ
	 * @param event
	 */
	protected onChangeApprover(event: React.ChangeEvent<HTMLSelectElement>) {
		const { data } = this.props;
		const { name, value } = event.target;
		const newData = Object.assign({}, data);
		newData[name] = value;
		this.props.setChangeApplicationData(newData);
	}

	/**
	 * 申請理由変更ハンドラ
	 * @param event
	 */
	protected changeApplication(event: React.MouseEvent<HTMLElement>) {
		const { data, userAttr, token } = this.props;
		const { careerID, classID } = this.state;

		// 入力チェック
		if (data.reason && data.reason.length > 200) {
			const message: IMessage = {
				content: 'CHK_E_0004',
				replacements: [i18n.t('ApplicationChangeForSkill_0004'), '200'],
			};
			this.setState({
				messages: [message],
				openErrorMessageDialog: true,
			});
			return;
		}

		const application: IApplication = {
			...data,
			careerID,
			classID,
			lang: userAttr.lang,
			locale: userAttr.locale,
			userId: userAttr.userId,
		};
		const stayMealData: IApprovalStayMealData[] = [];
		const applicationStayMeal: IApplicationStayMeal = {
			application,
			stayMealData,
		};
		this.props.saveChangeApplication(token, applicationStayMeal);
	}
}

const mapStateToProps = (state: IRootState) => ({
	data: state.imstat.changeApplication.data,
	dialogOpen: state.imstat.changeApplication.dialogOpen,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchChangeApplication: (
		token: string,
		arg: IFetchChangeApplicationParam
	) => {
		const s = ImstatScenarioFactory.createFetchChangeApplication(
			dispatch,
			token
		);
		s.run(arg);
	},
	onClose: () => dispatch(showChangeApplicationDialog({ dialogOpen: false })),
	pushHistory: (path: string) => dispatch(push(path)),
	saveChangeApplication: (
		token: string,
		application: IApplicationStayMeal
	) => {
		const s = ImstatScenarioFactory.createSaveChangeApplication(
			dispatch,
			token
		);
		s.run(application);
	},
	setChangeApplicationData: (data: IApplication) =>
		dispatch(setChangeApplicationData({ data })),
});

// tslint:disable-next-line: no-empty-interface
export interface IApplicationChangeForSkillProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	IApplicationChangeForSkillProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ApplicationChangeForSkill);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ApplicationChangeForSkill.tsx